import { render, staticRenderFns } from "./OurServices.vue?vue&type=template&id=4643bc8f"
var script = {}
import style0 from "./OurServices.vue?vue&type=style&index=0&id=4643bc8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports